import { isTpuLabellingEnabled } from "@/features/branding";
import { getTranslatedText } from "@/features/internationalisation";
import { anaHazards } from "@/lib/crg_apis/constants/hazards";
import { AnaHazardId } from "@/store/services/facades/types";
import { NO_DATA } from "@/utils/constants";

import type { ExposureStatus, ExposureStatusByReturnPeriod, ExposuresByHazard } from "@/types/exposure";
import { Scenario } from "../../../pe_aldd/schema";

export interface ExposuresOptions {
  mode?: "csv";
  filename?: {
    suffix?: string;
    prefix?: string;
  };
  headers?: string[];
}

// Re-export for backwards compatibility
export type { ExposureStatus, ExposureStatusByReturnPeriod, ExposuresByHazard };

export const getExposureStatusLabel = (status: ExposureStatus | null) => {
  if (status == "exposed") return "Exposed";
  if (status == "unexposed") return "Not Exposed";
  return NO_DATA;
};

const tpuHeaders = ["tpu", "subunit"];

export const getExposureHeaders = (regionType?: string) => [
  "analysis_id",
  "user_supplied_id",
  "latitude",
  "longitude",
  "address",
  "geocode_quality",
  ...(isTpuLabellingEnabled(regionType) ? tpuHeaders : []),
  "return_period",
];

export const getHeaderByExposureHazard = (hazard: AnaHazardId) =>
  `flood exposure_${getTranslatedText(`terms:hazards.${anaHazards[hazard].newId}`)}`.toLowerCase();

export const scenariosWithFloodExposure: Scenario[] = ["rcp85"];

/** The hazards Facades reports flood exposure for. */
export const availableExposureHazards = ["flood_riverine", "flood_surfacewater"] as const satisfies readonly AnaHazardId[];
export type ExposureHazard = (typeof availableExposureHazards)[number];

export const isExposureHazard = (hazard: string): hazard is ExposureHazard =>
  availableExposureHazards.some((exposureHazard) => exposureHazard === hazard);
